export default "__VITE_ASSET__DUQsE9IN__"